import { Tree } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { CommonNodeO2 } from "../../Obj2Tab/Obj2Nodes";
import { ObjectsStore } from "../facade";

interface PropsObjectsTree {
  store: ObjectsStore;
}

/**
 * Дерево объектов.
 *
 * Раскрытие асинхронное: `loadData` спрашивает у вкладки детей узла, а она уже
 * решает, что для этого нужно — детали объекта, значения справочника или
 * вложения значения. Дерево про эти различия не знает.
 *
 * `loadedKeys` передаётся снаружи намеренно: свой учёт загруженного дерево
 * ведёт неверно для нашего случая — после неудачных попыток оно пометит ветвь
 * загруженной и перестанет её запрашивать.
 */
export const ObjectsTree: React.FC<PropsObjectsTree> = observer(({ store }) => (
  <Tree<CommonNodeO2>
    className="idObjectsTree"
    treeData={store.treeData}
    showIcon
    selectedKeys={store.selectedKeys}
    onSelect={(keys) => store.safeSelect(keys[0] ?? null)}
    expandedKeys={store.expandedKeys}
    loadedKeys={store.loadedKeys}
    loadData={(node) => store.loadTreeNode(node.key)}
    onExpand={(_keys, { node, expanded }) => store.expand(node.key, expanded)}
  />
));
